export const ru = {
    recommended_hotel_hint: 'Коллеги часто выбирали этот отель для командировок и остались довольны',
};
